import React from "react";
import flowers from "../data/paisprefebruarie";
import FlowerContainer from "../components/FlowerContainer";

const PaisprezeceFebruarie = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete pentru 14 februarie"
      subtitle='Spune „Te iubesc" prin flori'
      storageKey="PAISPREZE_FEBRUARIE_SCROLL_POSITION"
    />
  );
};

export default PaisprezeceFebruarie;
